function displayText(value) {
  return value == null ? '' : String(value).trim()
}

function productTitle(item = {}) {
  item = item || {}
  return displayText(item.model) || displayText(item.name) || '未命名商品'
}

function productType(item = {}) {
  item = item || {}
  const name = displayText(item.name)
  const model = displayText(item.model)
  // 名称保存产品类型；旧数据把型号存入名称时，使用实际分类补充类型。
  return displayText(item.productType) || (name !== model && name !== '未命名商品' && name !== '未命名积分商品' ? name : '') ||
    displayText(item.subCategoryName) || displayText(item.categoryName) || displayText(item.category)
}

function productBrand(item = {}) {
  item = item || {}
  // 品牌只取真实品牌字段，不使用类目或商城名称替代。
  return displayText(item.brand) || '-'
}

function packagingQuantityText(item = {}) {
  item = item || {}
  return displayText(item.packagingQuantity) || '-'
}

module.exports = { productTitle, productType, productBrand, packagingQuantityText }
